import { render, staticRenderFns } from "./FaqsList.vue?vue&type=template&id=36733811&scoped=true&"
import script from "./FaqsList.vue?vue&type=script&lang=js&"
export * from "./FaqsList.vue?vue&type=script&lang=js&"
import style0 from "./FaqsList.vue?vue&type=style&index=0&id=36733811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36733811",
  null
  
)

export default component.exports